import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
interface FaqItem {
  question: string;
  answer: string;
}
interface FaqAccordionProps {
  items: FaqItem[];
}
export function FaqAccordion({
  items
}: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full max-w-2xl mx-auto space-y-2" data-id="element-11">
      {items.map((item, index) => <div key={index} className="bg-white rounded-lg border border-gray-100 overflow-hidden" data-id="element-12">
          <button onClick={() => toggleItem(index)} className="w-full flex items-center justify-between px-4 py-3 text-left focus:outline-none focus:ring-2 focus:ring-[#0F766E]/20" aria-expanded={openIndex === index} data-id="element-13">
            <span className="text-sm font-medium text-[#111111] pr-4" data-id="element-14">
              {item.question}
            </span>
            <span className="flex-shrink-0 text-[#0F766E]" data-id="element-15">
              {openIndex === index ? <Minus size={16} strokeWidth={2} data-id="element-16" /> : <Plus size={16} strokeWidth={2} data-id="element-17" />}
            </span>
          </button>

          <AnimatePresence initial={false} data-id="element-18">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.25,
          ease: 'easeInOut'
        }} data-id="element-19">
                <div className="px-4 pb-3 text-gray-600 text-xs leading-relaxed" data-id="element-20">
                  {item.answer}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}